import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function Footer(){
  return (
    <footer className="site-footer text-light py-5 mt-5" style={{ background: 'linear-gradient(135deg, #1a3a44, #2d5a6f)' }}>
      <Container fluid style={{ paddingLeft: '50px', paddingRight: '50px' }}>
        <Row className="mb-4 g-4" style={{ justifyContent: 'space-between' }}>
          <Col md={4} className="text-md-start">
            <h6 className="fw-bold mb-3" style={{ color: '#e8943a' }}>Northwest Bible Fellowship</h6>
            <p className="small text-light opacity-75 mb-0">A group of born again believers committed to following the Bible and building community in Pune's northwest.</p>
          </Col>
          <Col md={4} className="text-center">
            <h6 className="fw-bold mb-3" style={{ color: '#e8943a' }}>Meeting Times</h6>
            <p className="small text-light opacity-75 mb-1">Sundays: 9:30 AM - 12:30 PM</p>
            <p className="small text-light opacity-75 mb-0">Wednesdays: 8:30 PM - 9:30 PM</p>
          </Col>
          <Col md={4} className="text-end">
            <h6 className="fw-bold mb-3" style={{ color: '#e8943a' }}>Connect</h6>
            <p className="small mb-0">
              <a href="#contact" className="text-warning fw-semibold text-decoration-none">Contact us</a> <br/>
              <a href="#donate" className="text-warning fw-semibold text-decoration-none">Give online</a>
            </p>
          </Col>
        </Row>
        <hr style={{ borderColor: 'rgba(232, 148, 58, 0.3)' }} />
        <Row>
          <Col className="text-center">
            <p className="mb-0 small text-light opacity-75">© {new Date().getFullYear()} Northwest Bible Fellowship • All rights reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}